import { Modal, Button } from "antd";
import { useNavigate } from "react-router-dom";

const InsufficientCreditsModal = ({ visible, message, onClose }) => {
  const navigate = useNavigate();

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width={400}
      styles={{
        content: {
          backgroundColor: "#f9fafb",
          borderRadius: "12px",
          padding: "24px",
        },
        mask: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
      }}
    >
      <div className="flex flex-col items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-12 w-12 text-[#ef4444] mb-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <h2 className="text-lg font-semibold text-gray-800 mb-2">
          Insufficient Credits
        </h2>
        {message ?
            <div className="text-gray-600 text-center mb-6" dangerouslySetInnerHTML={{ __html: message }} />
        :
            <p className="text-gray-600 text-center mb-6">
            You have run out of credits. Please recharge to continue.
            </p>
        }
        <Button
          type="primary"
          onClick={() => {
            onClose();
            navigate("/recharge");
          }}
          style={{
            backgroundColor: "#ef4444",
            borderColor: "#ef4444",
            borderRadius: "8px",
            padding: "8px 24px",
            height: "40px",
            fontSize: "16px",
            fontWeight: "500",
          }}
        >
          Subscribe Now
        </Button>
      </div>
    </Modal>
  );
};

export default InsufficientCreditsModal;